/**
 * リストの値を大・中・小に分類する
 * @param {Array<string>} list
 */
export const cassifyListAsLMS = (list: string[] | undefined) => {
  if (!list) return {};

  const lList = list
    .filter((item) => /L$/.test(item))
    .map((item) => item.replace('L', ''));
  const mList = list
    .filter((item) => /M$/.test(item))
    .map((item) => item.replace('M', ''));
  const sList = list
    .filter((item) => /S$/.test(item))
    .map((item) => item.replace('S', ''));

  return {
    lList: !lList.length ? undefined : lList,
    mList: !mList.length ? undefined : mList,
    sList: !sList.length ? undefined : sList,
  };
};

/**
 * リストの値を大・中・小に分解する
 * @param {Array<string>} list
 * @returns {Array<string>}
 */
export const disassemblyListAsLMS = (list: string[] | undefined) => {
  if (!list) return {};

  let lList = list
    .filter((item) => /L$/.test(item))
    .map((item) => item.replace('L', ''));
  let mList = list
    .filter((item) => /M$/.test(item))
    .map((item) => item.replace('M', ''));
  const sList = list
    .filter((item) => /S$/.test(item))
    .map((item) => item.replace('S', ''));

  if (mList.length !== 0) {
    lList = [mList[0].substring(0, 2)];
  }
  if (sList.length !== 0) {
    lList = [sList[0].substring(0, 2)];
    mList = [sList[0].substring(0, 4)];
  }

  return {
    lList: !lList.length ? undefined : lList,
    mList: !mList.length ? undefined : mList,
    sList: !sList.length ? undefined : sList,
  };
};
